import Styled from 'styled-components'

export default Styled.div`
  width: ${props => props.theme.width}rem;
  max-width: calc(100% - 4rem);
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/Content/index.js